module.exports = __webpack_public_path__ + "img/right-static-desktop.1205ecc.png";